import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import './assets/common.css'
import router from './router'
import store from './store'
import moment from 'moment';
import infiniteScroll from 'vue-infinite-scroll'
import ApiClient from './api/src/ApiClient'
import {inDev} from '@/utils/env.js'
import permissions from '@/utils/permissions.js'
import hasPermissions from '@/utils/hasPermissions.js'
// 加载 element 组件库
import ElementUI from 'element-ui'


ApiClient.ajaxError = async function(response) {
  console.log(response)
  if(response.status == 401){
    window.location.href = `/login?redirect=${response.url}`
  }
  throw await response.json()
}
Vue.prototype.$permissions = permissions
Vue.prototype.$hasPermissions = hasPermissions

// 全局注册 element 组件库
Vue.use(ElementUI)
Vue.use(Antd)
Vue.use(infiniteScroll)
Vue.prototype.inDev = inDev

Vue.config.productionTip = false
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
if(process.env.NODE_ENV == 'development'){
  console.log('https://fm-cloud-general-uestcp.oss-cn-chengdu.aliyuncs.com/')
  Vue.prototype.$ossHost = 'https://fm-cloud-general-uestcp.oss-cn-chengdu.aliyuncs.com/'
  Vue.prototype.$serverHost = 'http://localhost:8091/'
}else{
  console.log('https://fm-cloud-general-uestcp.oss-cn-chengdu.aliyuncs.com/')
  Vue.prototype.$ossHost = 'https://fm-cloud-general-uestcp.oss-cn-chengdu.aliyuncs.com/'
  Vue.prototype.$serverHost = 'https://admin.fmyundianji.com/'
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
